<div class="container" mat-dialog-content>
    <h2>Email Receipt</h2>

    <div>
        Send receipt to {{invoice.customer.name}} &lt;{{invoice.customer.email}}&gt;
    </div>

    <div class="emailbody mat-elevation-z2" [innerHtml]="body.HTML | byPassSecurity"></div>

</div>

<div mat-dialog-actions>
    <button (click)="send()" mat-raised-button>Email</button>
    <button (click)="close()" mat-raised-button>Close</button>
</div>